// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import '@/assets/global.css'
import '@/assets/icon/iconfont.css'
import App from './App'
import router from './router'
import VueSimpleVerify from 'vue-simple-verify'
import '../node_modules/vue-simple-verify/dist/vue-simple-verify.css'
import VueClipboard from 'vue-clipboard2'
import { Lazyload } from 'mint-ui'
import VueCookies from 'vue-cookies'
import imgPre from 'img-pre'

Vue.component('vue-simple-verify', VueSimpleVerify)
Vue.config.productionTip = false
Vue.use(MintUI)
Vue.use(VueClipboard)
Vue.use(Lazyload)
Vue.use(VueCookies)
Vue.use(imgPre)
// Vue.component(Header.name, Header);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  // router,
  // components: { App },
  // template: '<App/>'
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js